export default class MassiaInputController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'MassiaSelectService',
		'notification',
		'$location',
		'$translate',
		'SharedDataService',
		'$attrs',
		'MassiaSelectSupervisorService'
	];

	constructor(
		$scope,
		$state,
		$stateParams,
		MassiaInputService,
		notification,
		$location,
		$translate,
		SharedDataService,
		$attrs,
		MassiaSelectSupervisorService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.MassiaInputService = MassiaInputService;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$attrs = $attrs;
		this.MassiaSelectSupervisorService = MassiaSelectSupervisorService;

		this.searchText = '';
		this.name = this.$attrs.name;
		this.filteredOptions = [];
		this.messageError = '';
		this.error = false;
	}

	async $onInit() {
		// Créer la promise pour le supervisor
		this.readyPromise = new Promise((resolve) => (this._resolveReady = resolve));
		//Abonnement au Supervisor
		this.MassiaSelectSupervisorService.addController(this);

		this.isEditMode = false;

		var dataObject = {
			value: this.customType == 'number' ? Number(this.ngModel) : String(this.ngModel),
			messageType: '',
			message: ''
		};

		this.$scope.$watch(
			() => this.ngModel,
			(newValue) => {
				if (this.config && this.config.masque == 'numeriquePoids') {
					this.MasqueSaisie3Decimals();
				}
				var dataObjectReload = {
					value: this.customType == 'number' ? Number(newValue) : String(newValue),
					messageType: '',
					message: ''
				};
				this.SharedDataService.setData(this.name, dataObjectReload);
				if (this.ngChange) {
					this.ngChange();
				}
			}
		);
		console.log(this.config);

		this.SharedDataService.setData(this.name, dataObject);

		//On prévient le superviseur qu'on est prêt
		this.initComplete = true;
		this._resolveReady();
	}

	verifyForm(newValueObject) {
		this.error = false;
		if (newValueObject.messageType === 'error') {
			this.error = true;
			this.messageError = newValueObject.message;
		}
		this.ngModel = newValueObject.value;
	}

	MasqueSaisie3Decimals() {
		if (this.ngModel) {
			// Remplacer les virgules par des points pour uniformiser le format
			this.ngModel = this.ngModel.replace(',', '.');

			// Retirer tous les caractères non numériques sauf les points
			this.ngModel = this.ngModel.replace(/[^0-9.]/g, '');

			// Limiter le nombre de décimales à 3
			const parts = this.ngModel.split('.');
			if (parts[1] && parts[1].length > 3) {
				parts[1] = parts[1].substring(0, 3);
				this.ngModel = parts.join('.');
			}
		}
	}

	$onDestroy() {
		this.MassiaSelectSupervisorService.removeController(this);
	}

	reset() {
		this.ngModel = 0;
		this.searchText = '';
		this.options = [];
	}

	onFocus() {
		this.isFocused = true;
	}
}
